// Single source of truth for PostHog feature flag keys.
//
// Declaring each key here (rather than as inline string literals) keeps the
// hook, the components that gate on a flag, and the tests that exercise them
// referring to the exact same value — no magic strings to drift apart.

// Gates the Profile & Stats experience (nav link + /profile route). Defaults
// OFF until explicitly enabled in PostHog. The matching deterministic URL
// override is `?ff_profile-stats=true|false`.
export const PROFILE_STATS_FLAG = "profile-stats";

// Per-language release gate. Base languages (see BASE_LANGUAGE_CODES in
// src/i18n) always ship; every other translated language is shown only when its
// `lang-<code>` flag is enabled in PostHog. This lets us roll languages out
// incrementally without a deploy. The deterministic URL override is
// `?ff_lang-<code>=true|false` (e.g. `?ff_lang-de=true`).
export const languageFlagKey = (code: string): string => `lang-${code}`;
